import LabelSubtitle from "../../../../../../typo/LabelSubtitle";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Stack, styled } from "@mui/material";
import { LOCAL_STORAGE_KEYS } from "../../../../../../../config/enums";
import { CustomStoreElementsContext } from '../../../../../../../utils/contextes/CustomStoreElementsContext'

const SpecificityContainer = styled(Stack)({
    width: '36%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    borderLeft: '2px solid rgba(0, 0, 0, 0.1)',
    gap: '6px'
})

const Row = styled(Stack)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
    gap: '12px'
})
const ReferenceItem = () => {

    const { t } = useTranslation()
    const { nomCommercial } = useContext(CustomStoreElementsContext)

    const fittingA = localStorage.getItem(LOCAL_STORAGE_KEYS.FITTING_A_PART_NUMBER) ?? '';
    const fittingB = localStorage.getItem(LOCAL_STORAGE_KEYS.FITTING_B_PART_NUMBER) ?? '';

    const headChars = (s: string) => (s.startsWith('#') ? s.slice(2, 4) : s.slice(1, 3));

    const afterDash = (s: string) => (s.split('-')[1] ?? '').slice(0, 2);

    const lastDigits = (s: string) => {
        const part = s.split('-').pop() ?? '';
        return part.replace(/\D/g, '');
    };

    return (
        <>
            <LabelSubtitle>{t('screens.selector.assembly.recap.reference')}</LabelSubtitle>
            <SpecificityContainer>
                <Row>
                    <LabelSubtitle>{`${nomCommercial} - ${localStorage.getItem(LOCAL_STORAGE_KEYS.HOSE_PART_NUMBER)?.split('-')[0]}${headChars(fittingA)}${headChars(fittingB)}${afterDash(fittingA)}${afterDash(fittingB)}${lastDigits(fittingA)}${localStorage.getItem(LOCAL_STORAGE_KEYS.ASSEMBLY_LENGTH)}${localStorage.getItem(LOCAL_STORAGE_KEYS.FITTINGS_ANGLE)}`}</LabelSubtitle>
                </Row>
            </SpecificityContainer>
        </>


    )
}

export default ReferenceItem
